// TODO: What we are doing explain even in persist login
import React from "react";
import { Outlet } from "react-router-dom";

// Utility function to check if the access token is valid
const isAuthenticated = () => {
  return sessionStorage.getItem("accessToken") !== null;
};

// Protected Route Component
export const ProtectedRoute = ({ setIsOpenInvalidTokenModal }) => {
  // Check authentication status
  if (!isAuthenticated()) {
    // Redirect to login page if not authenticated
    return setIsOpenInvalidTokenModal(true);
    // <Navigate to="/" replace />;
  }

  // Render child routes if authenticated
  return <Outlet />;
};
